import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';

/** Material UI */
import Button from '@mui/material/Button';

const Salida = () => {
    let navigate = useNavigate();

    return (
        <div className="row justify-content-center">
            <h4 className="text-center">Solicitud realizada con exito</h4>
            {/* <div style={{ width: 10, height: 10 }}>
                <img src="/img/check_icon.png" alt="Desvinculación" />
            </div> */}
            <Button variant="contained" style={{ width: 100 }} onClick={() => navigate("/desvincular")}>Volver</Button>
        </div>
    )
}

export default Salida;